import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";

import { ClientService } from "../../../services/client.service";
import { emptyPerson, IPerson } from "../../../model/person";
import { LoginService } from "../../../services/login.service";
import { SpinnerService } from '../../../services/spinner.service';
import { ToastsManager } from 'ng2-toastr';
import { TranslateService } from '@ngx-translate/core';

declare const afirma: any;

@Component({
  selector: 'app-cli-client',
  templateUrl: './cli-client.component.html',
  styleUrls: ['./cli-client.component.css']
})
export class CliClientComponent implements OnInit {

  /**
   *
   * @type {boolean}
   */
  renderNewClient: boolean = false;

  /**
   * @type {boolean}
   */
  isAcceptedUseConditions: boolean = false;

  /**
   * @type {string}
   * Formulario firma en cliente
   */
  xml: string;

  /**
   *
   * @type {IPerson}
   */
  person: IPerson = emptyPerson;

  /**
   *
   * @param {LoginService} loginService
   * @param {ClientService} clientService
   * @param {Router} router
   * @param {SpinnerService} spinnerService
   */
  constructor(
    private loginService: LoginService,
    private clientService: ClientService,
    private router: Router,
    private toastr: ToastsManager,
    private translate: TranslateService,
    private spinnerService: SpinnerService
  ) { }

  ngOnInit() {
    this.person = this.loginService.getPerson();
  }

  /**
   * Method invoked when the new invoicing services button is clicked
   * to show the creation form of invoicing sevices
   */
  createClientClicked() {
    this.renderNewClient = !this.renderNewClient;
  }


  /**
   * Save the client
   */
  saveClient() {
    this.clientService.validateClient()
      .subscribe(
        result => {
          afirma.init('/assets/afirma/miniapplet_1.7');
          this.xml = result['xml'];
          this.sign();
        },
        error => {
          console.log(error);
        });
  }

  /**
   * Sign the form
   */
  sign() {
    document.getElementById('div_sign_error').innerText = '';
    afirma.sn = '';
    afirma.formulario = "firma";
    afirma.submit = "firma_submit";
    afirma.error = "div_sign_error";
    afirma.formularioweb = this.xml;
    afirma.prefix = 'firma';
    afirma.tipo_firma = 'XAdES';
    afirma.intentos_autofirma = 0;
    afirma.firmar(this.sign_submit, this.sign_error);
  }

  /**
   *
   * @param {string} signature
   * @param {ToastsManager} toastr
   * @param {TranslateService} translate
   */
  sign_submit = (signature: string) => {
    this.spinnerService.setSpinner(true);
    this.clientService.saveClient(signature)
      .subscribe(() => {
        this.translate.get("cli.noClient.createOKToast").subscribe((res: string) => {
              this.toastr.info(res).then();
            });
        this.router.navigateByUrl('',
          {skipLocationChange: true}).then(
          ()=> this.router.navigate(["/cliente"])
        );
      }, error => {
        this.generateSignError(error.errors[0]);
      });
  };

  /**
   *
   * @param {string} error
   */
  sign_error = (error: string) => {
    this.generateSignError(error);
  };

  onCancelClicked(){
    this.renderNewClient = !this.renderNewClient;
  }

  /**
   *
   * @param error
   */
  private generateSignError(error) {
    let span = document.createElement('span');
    span.innerText = error;
    document.getElementById('div_sign_error').appendChild(span);
  }

}



// WEBPACK FOOTER //
// ./src/app/app-manager/client/cli-client/cli-client.component.ts